import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "./constants";

/** Language for a new agent, rule or template: the user's interface language when Sonic supports it. */
export const languageForUi = (uiLanguage) => {
  const prefix = (uiLanguage || "").slice(0, 2).toLowerCase();
  const match = SUPPORTED_LANGUAGES.find((l) => l.value.slice(0, 2).toLowerCase() === prefix);
  return match ? match.value : DEFAULT_LANGUAGE;
};

/** Heuristic script-language guess for mismatch warnings (not NLP). */

export const detectScriptLanguage = (text) => {
  if (!text || !text.trim()) return null;
  if (/[\u0600-\u06FF]/.test(text)) return "ar-SA";
  if (/[şğİıöüçŞĞÖÜÇ]/.test(text)) return "tr-TR";
  if (/[äöüßÄÖÜ]/.test(text)) return "de-DE";
  return "en-US";
};

export const languagesMayMismatch = (scriptText, selectedLanguage) => {
  const detected = detectScriptLanguage(scriptText);
  if (!detected || !selectedLanguage) return false;
  const selPrefix = selectedLanguage.slice(0, 2).toLowerCase();
  const detPrefix = detected.slice(0, 2).toLowerCase();
  return selPrefix !== detPrefix;
};
